import React, { useEffect, useState } from "react";
import Select from "react-select";

const selectStyles = {
  menu: () => ({ boxShadow: "inset 0 1px 0 rgba(0, 0, 0, 0.1)" }),
};

const SelectDropDown = ({
  data,
  itemSelected = null,
  setItemHandler = () => {},
  placeholder = null,
  open = false,
  textNotFoundedItem = "دسته صنفی پیدا نشد",
}) => {
  const [value, setValue] = useState(itemSelected);
  const [isOpen, setIsOpen] = useState(open);
  const NoOptionsMessageComponent = (
    <NoOptionsMessage textNotFoundedItem={textNotFoundedItem} />
  );

  useEffect(() => {
    setValue(itemSelected);
  }, [itemSelected]);

  return (
    <Dropdown
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      target={
        <div onClick={() => setIsOpen((prev) => !prev)} isSelected={isOpen}>
          {value
            ? `${value.label}`
            : placeholder
            ? placeholder
            : "عنوان دسته جستجو کنید..."}
        </div>
      }
    >
      <Select
        classNames="hilite-select-dropdown-container"
        classNamePrefix="hilite-select-dropdown"
        autoFocus
        backspaceRemovesValue={false}
        components={{
          DropdownIndicator,
          IndicatorSeparator: null,
          NoOptionsMessageComponent,
        }}
        controlShouldRenderValue={false}
        hideSelectedOptions={false}
        isClearable={false}
        menuIsOpen
        onChange={(newValue) => {
          setValue(newValue);
          setIsOpen(false);
          setItemHandler(newValue);
        }}
        options={data}
        placeholder={placeholder ? placeholder : "عنوان دسته جستجو کنید..."}
        tabSelectsValue={false}
        value={value}
      />
    </Dropdown>
  );
};

const NoOptionsMessage = (textNotFoundedItem) => {
  return (
    <div className="text-center p-2">
      <span>{textNotFoundedItem}</span>
    </div>
  );
};

const Menu = (props) => {
  return (
    <div
      className="bg-white w-100 position-absolute mt-2 border border-top-0 hilite-select-dropdown-menu"
      style={{
        right: "0px",
      }}
      {...props}
    />
  );
};
const Blanket = () => (
  <div
    css={{
      bottom: 0,
      left: 0,
      top: 0,
      right: 0,
      position: "fixed",
      zIndex: 1,
    }}
  />
);
const Dropdown = ({ children, isOpen, target, onClose }) => (
  <div className="form-control position-relative select-dropdown">
    {target}
    {isOpen ? <Menu>{children}</Menu> : null}
    {isOpen ? <Blanket onClick={onClose} /> : null}
  </div>
);

const DropdownIndicator = () => (
  <span className="pl-2">
    <i className="fa fa-search"></i>
  </span>
);

export default SelectDropDown;
